// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useRef } from "react";
// import "./registrationfrom.css";
// // import DropDown from "./Dropdown";
// // import FormInputs from "./FormInputs";
// import DropDown from "../../Components/Shared/Dropdown/Dropdown";
// import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
// import AWS from "aws-sdk";
// import UploadImgIcon from "../../Assets/Images/EployeeRegistration/icon-image.png";
// import EditIcon from "../../Assets/Images/EployeeRegistration/edit_icon.png";
// import { fetchReligionsData } from "../../Redux/EmployeeRegistration/religionSlice";
// import { fetchGenderData } from "../../Redux/EmployeeRegistration/genderSlice";
// import { fetchBloodGroupData } from "../../Redux/EmployeeRegistration/bloodgroupSlice";
// import { fetchSalutationData } from "../../Redux/EmployeeRegistration/salutatinSlice";
// import { fetchCategorynData } from "../../Redux/EmployeeRegistration/categorySlice";
// import CropperModal from "../StudentRegistration/Cropper";

// function PersonalInfo({ setPersonalInfo }) {
//   const dispatch = useDispatch();
//   const [src, setSrc] = useState(null);
//   const { religiondata } = useSelector((state) => state.religion);
//   const { genderdata } = useSelector((state) => state.gender);
//   const { bloodgroupdata } = useSelector((state) => state.bloodgroup);
//   const { salutationdata } = useSelector((state) => state.salutations);
//   const { categorydata } = useSelector((state) => state.categories);
//   const [isOpen, setIsOpen] = useState(true);
//   const [uploadedImageUrl, setUploadedImageUrl] = useState("");
//   const cropperRef = useRef(null);
//   const [croppedImageBlob, setCroppedImageBlob] = useState(null);
//   const [crop, setCrop] = useState(null);
//   const [image, setImage] = useState(null);
//   const [showCropper, setShowCropper] = useState(false);
//   const [fileName, setFileName] = useState("");
//   const [values, setValues] = useState({
//     salutation_id: 0,
//     gender_id: 0,
//     blood_group_id: 0,
//     religion_id: 0,
//     category_id: 0,
//     emp_first_name: "",
//     emp_middle_name: "",
//     emp_last_name: "",
//     dob: new Date().toISOString(),
//     age: null,
//     married_flag: "",
//     fathers_name: "",
//     fathers_mob_no: "",
//     mothers_name: "",
//     mothers_mob_no: "",
//     spouse_name: "",
//     spouse_mob_no: "",
//     emergency_contact_name: "",
//     emrgency_contact_mob_no: "",
//     photograph: "",
//   });

//   setPersonalInfo(values);
  
//   useEffect(() => {
//     dispatch(fetchGenderData());
//     dispatch(fetchBloodGroupData());
//     dispatch(fetchReligionsData());
//     dispatch(fetchSalutationData());
//     dispatch(fetchCategorynData());
//   }, [dispatch]);

//   const onChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "dob") {
//       const selectedDate = new Date(value);
//       const currentDate = new Date();
//       const ageDiff = currentDate.getFullYear() - selectedDate.getFullYear();
//       const isBirthdayPassed =
//         currentDate.getMonth() < selectedDate.getMonth() ||
//         (currentDate.getMonth() === selectedDate.getMonth() &&
//           currentDate.getDate() < selectedDate.getDate());
//       const age = isBirthdayPassed ? ageDiff - 1 : ageDiff;
//       setValues({ ...values, [name]: value, age: age });
//     } else {
//       setValues({ ...values, [name]: value });
//     }
//     setPersonalInfo((prevInfo) => ({ ...prevInfo, [name]: value }));
//   };
//   // const [croppedImageBlob, setCroppedImageBlob] = useState(null);

//   const toggleAccordion = () => {
//     setIsOpen(!isOpen);
//   };

//   //images save in s3 bucket
//   const s3 = new AWS.S3({
//     accessKeyId: "AKIAUFB5JPBW5EP45JD7",
//     secretAccessKey: "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",
//     region: "ap-south-1",
//   });

//   const [zoom, setZoom] = useState(1);
//   const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

//   // Add these new functions before your return statement
//   const onCropComplete = (croppedArea, croppedAreaPixels) => {
//     setCroppedAreaPixels(croppedAreaPixels);
//   };

//   const createImage = (url) =>
//     new Promise((resolve, reject) => {
//       const image = new Image();
//       image.addEventListener("load", () => resolve(image));
//       image.addEventListener("error", (error) => reject(error));
//       image.src = url;
//     });

//   const getCroppedImg = async (imageSrc, pixelCrop) => {
//     const image = await createImage(imageSrc);
//     const canvas = document.createElement("canvas");
//     const ctx = canvas.getContext("2d");

//     canvas.width = pixelCrop.width;
//     canvas.height = pixelCrop.height;

//     ctx.drawImage(
//       image,
//       pixelCrop.x,
//       pixelCrop.y,
//       pixelCrop.width,
//       pixelCrop.height,
//       0,
//       0,
//       pixelCrop.width,
//       pixelCrop.height
//     );

//     return new Promise((resolve) => {
//       canvas.toBlob((blob) => {
//         resolve(URL.createObjectURL(blob));
//       }, "image/jpeg");
//     });
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setFileName(file.name);
//       const reader = new FileReader();
//       reader.onload = () => {
//         setSrc(reader.result);      // <-- Added line so CropperModal gets the image source
//         setImage(reader.result);
//         setShowCropper(true);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleCroppedImage = (croppedFile) => {
//     // Update image states
//       setCroppedImageBlob(croppedFile);
//       setImage(URL.createObjectURL(croppedFile));

//       // Update form values
//       setValues((prev) => ({
//         ...prev,
//         photograph: croppedFile,
//       }));

//       // Update parent component
//       setPersonalInfo((prev) => ({
//         ...prev,
//         IMG: croppedFile,
//       }));

//       // Reset cropper state
//       setShowCropper(false);
//       setSrc(null);
//     };

//   const handleCropComplete = async () => {
//     if (!cropperRef.current) return;

//     try {
//       const dataUrl = cropperRef.current.getImage().toDataURL();
//       const result = await fetch(dataUrl);
//       const blob = await result.blob();

//       const timestamp = new Date().getTime();
//       const filename = `profile_${timestamp}.jpg`;

//       const file = new File([blob], filename, {
//         type: "image/jpeg",
//         lastModified: Date.now(),
//       });

//       handleCroppedImage(file);
//     } catch (err) {
//       console.error("Image processing error:", err);
//     }
//   };

//   // Update handleDeleteImage function
//   const handleDeleteImage = () => {
//       // Clear image states
//       setImage(null);
//       setSrc(null);
//       setFileName("No selected file");
//       setCroppedImageBlob(null);

//       // Clear form values
//       setValues((prev) => ({
//         ...prev,
//         photograph: null,
//       }));

//       // Clear parent component state
//       setPersonalInfo((prev) => ({
//         ...prev,
//         IMG: null,
//       }));

//       // Close cropper if open
//       setShowCropper(false);
//     };

//   useEffect(() => {
//     const currentValues = { ...values };
//     if (croppedImageBlob) {
//       currentValues.IMG = croppedImageBlob;
//       // Add console log to verify image data
//       console.log("PersonalInfo - Sending image:", {
//         imageSize: croppedImageBlob.size,
//         imageType: croppedImageBlob.type,
//         imageName: croppedImageBlob.name,
//       });
//     }
//     setPersonalInfo(currentValues);
//   }, [values, croppedImageBlob]);
  
//   return (
//     <div className="personal-info">
//       <div className="personal-header">
//         <div className="header">
//           <h2>personal information</h2>
//           <img src={EditIcon} alt="icon" />
//         </div>
//         <div className="accordion-btn" onClick={toggleAccordion}>
//           {isOpen ? (
//             <div className="minus"></div>
//           ) : (
//             <div className="plus">+</div>
//           )}
//         </div>
//       </div>
//       {isOpen &&
//         religiondata &&
//         genderdata &&
//         bloodgroupdata &&
//         salutationdata &&
//         categorydata && (
//           <div className="accordion-content">
//             <div className="grid-container">
//               <div className="item1" style={{ display: "flex" }}>
//                 <div
//                   className="selecte-dropdown-items"
//                   style={{ width: "40%" }}
//                 >
//                   <div style={{ marginTop: "2px" }}>
//                     {" "}
//                     <DropDown
//                       label="Salutation"
//                       // selected={values.salutation_id}
//                       setSelected={(selectedOption) =>
//                         setValues({ ...values, salutation_id: selectedOption })
//                       }
//                       options={salutationdata.map((salutation) => ({
//                         label: salutation.description,
//                         id: salutation.salutation_id,
//                       }))}
//                       isRequired={true}
//                     />
//                   </div>
//                 </div>
//                 <div style={{ width: "100%" }}>
//                   <FormInputs
//                     label="First Name"
//                     type="text"
//                     name="emp_first_name"
//                     value={values.emp_first_name}
//                     onChange={onChange}
//                     required
//                     maxlength="50"
//                     pattern="[A-Za-z]{1,50}"
//                   />
//                 </div>
//               </div>
//               <div className="item2">
//                 <FormInputs
//                   label="Middle Name"
//                   type="text"
//                   name="emp_middle_name"
//                   value={values.emp_middle_name}
//                   onChange={onChange}
//                   maxlength="50"
//                   pattern="[A-Za-z]{1,50}"
//                 />
//               </div>
//               <div className="item3">
//                 <FormInputs
//                   label="Last Name"
//                   type="text"
//                   name="emp_last_name"
//                   value={values.emp_last_name}
//                   onChange={onChange}
//                   maxlength="50"
//                   pattern="[A-Za-z]{1,50}"
//                   required
//                 />
//               </div>
//               <div className="item4">
//                 <FormInputs
//                   label="Date of Birth"
//                   type="date"
//                   name="dob"
//                   value={values.dob}
//                   onChange={onChange}
//                 />
//               </div>
//               <div className="item5">
//                 <FormInputs
//                   label="Age"
//                   type="number"
//                   name="age"
//                   value={values.age}
//                   onChange={onChange}
//                   required
//                   max="9999"
//                 />
//               </div>
//               <div className="item6">
//                 <div className="selecte-dropdown-items">
//                   <DropDown
//                     label="Gender"
//                     setSelected={(selectedOption) =>
//                       setValues({ ...values, gender_id: selectedOption })
//                     }
//                     options={genderdata.map((gender) => ({
//                       label: gender.gender_name,
//                       id: gender.gender_id,
//                     }))}
//                     isRequired={true}
//                   />
//                 </div>
//               </div>
//               <div className="item7">
//                 <div className="selecte-dropdown-items">
//                   {/* <DropDown
//                   label="Blood Group"
//                   setSelected={(selectedOption) =>
//                     setValues({ ...values, blood_group_id: selectedOption })
//                   }
//                   options={bloodgroupdata.map((bloodgr) => ({
//                     label: bloodgr.blood_group_name,
//                     id: bloodgr.blood_group_id,
//                   }))}
//                 /> */}

//                   <DropDown
//                     label="Blood Group"
//                     setSelected={(selectedOption) =>
//                       setValues({
//                         ...values,
//                         blood_group_id: selectedOption ? selectedOption : 1,
//                       })
//                     }
//                     options={bloodgroupdata.map((bloodgr) => ({
//                       label: bloodgr.blood_group_code,
//                       id: bloodgr.blood_group_id,
//                     }))}
//                     isRequired={true}
//                   />
//                 </div>
//               </div>
//               <div className="item8">
//                 <div className="selecte-dropdown-items">
//                   <DropDown
//                     label="Religion"
//                     setSelected={(selectedOption) =>
//                       setValues({ ...values, religion_id: selectedOption })
//                     }
//                     options={religiondata.map((rel) => ({
//                       label: rel.religion_name,
//                       id: rel.religion_id,
//                     }))}
//                     isRequired={true}
//                   />
//                 </div>
//               </div>
//               <div className="item9">
//                 <div className="selecte-dropdown-items">
//                   <DropDown
//                     label="Category"
//                     setSelected={(selectedOption) =>
//                       setValues({
//                         ...values,
//                         category_id: selectedOption ? selectedOption : 1,
//                       })
//                     }
//                     options={categorydata.map((cat) => ({
//                       label: cat.category_desc,
//                       id: cat.category_id,
//                     }))}
//                     isRequired={true}
//                   />
//                 </div>
//               </div>
//               <div className="item10">
//                 <FormInputs
//                   label="Father’s Name"
//                   type="text"
//                   name="fathers_name"
//                   value={values.fathers_name}
//                   onChange={onChange}
//                   required
//                   maxlength="200"
//                   pattern="[A-Za-z, ]{1,200}"
//                 />
//               </div>
//               <div className="item11" style={{ display: "flex" }}>
//                 <FormInputs
//                   label="Father’s Mobile Number"
//                   type="text"
//                   name="fathers_mob_no"
//                   value={values.fathers_mob_no}
//                   onChange={onChange}
//                   pattern="[0-9]{10,11}"
//                   maxLength={10}
//                 />
//               </div>
//               <div
//                 className="item12"
//                 style={{
//                   gridRowStart: "4",
//                   gridRowEnd: "8",
//                   gridColumnStart: "3",
//                   gridColumnEnd: "3",
//                 }}
//               >
//                 <div style={{ width: "100%" }}>
//                   <label>Photograph</label>
//                   <div className="input-image">
//                     <div className="input-image-field">
//                       <input
//                         type="file"
//                         accept="image/*"
//                         name="photograph"
//                         className="input-field"
//                         hidden
//                         onChange={handleImageChange}
//                       />
//                       {!showCropper ? (
//                         <>
//                           {image ? (
//                             <div
//                               style={{
//                                 width: "200px",
//                                 height: "200px",
//                                 overflow: "hidden",
//                                 border: "1px solid #ccc",
//                                 borderRadius: "4px",
//                               }}
//                             >
//                               <img
//                                 className="uploaded-img"
//                                 src={image}
//                                 alt={fileName}
//                                 style={{
//                                   width: "100%",
//                                   height: "100%",
//                                   objectFit: "cover",
//                                 }}
//                               />
//                             </div>
//                           ) : (
//                             <div className="icon-img-container">
//                               <img
//                                 src={UploadImgIcon}
//                                 alt="upload icon"
//                                 className="icon-img"
//                               />
//                             </div>
//                           )}
//                         </>
//                       ) : (
//                         <div
//                           style={{
//                             position: "relative",
//                             width: "100%",
//                             height: "300px",
//                           }}
//                         >
//                           <CropperModal src={src} cropperRef={cropperRef} />
//                         </div>
//                       )}
//                     </div>
//                     <div className="image-btns-container">
//                       {showCropper ? (
//                         <>
//                           <div
//                             className="replace-image-btn"
//                             style={{ marginBottom: "10px" }}
//                             onClick={handleCropComplete}
//                           >
//                             Save Changes
//                           </div>
//                           <div
//                             className="replace-image-btn"
//                             onClick={() =>
//                               document.querySelector(".input-field").click()
//                             }
//                           >
//                             Replace
//                           </div>
//                           <div
//                             className="del-image-btn"
//                             onClick={handleDeleteImage}
//                           >
//                             Delete
//                           </div>
//                         </>
//                       ) : (
//                         <>
//                           <div
//                             className="replace-image-btn"
//                             onClick={() =>
//                               document.querySelector(".input-field").click()
//                             }
//                           >
//                             {image ? "Replace" : "Upload"}
//                           </div>
//                           {image && (
//                             <>
//                               <div
//                                 className="del-image-btn"
//                                 onClick={handleDeleteImage}
//                               >
//                                 Delete
//                               </div>
//                               {/* <div
//                                 className="replace-image-btn"
//                                 onClick={handleCropComplete}
//                               >
//                                 Save Changes
//                               </div> */}
//                             </>
//                           )}
//                         </>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="item13">
//                 <FormInputs
//                   label="Mother’s Name"
//                   type="text"
//                   name="mothers_name"
//                   value={values.mothers_name}
//                   onChange={onChange}
//                   maxlength="200"
//                   pattern="[A-Za-z, ]{1,200}"
//                 />
//               </div>
//               <div className="item14">
//                 <FormInputs
//                   label="Mother’s Mobile Number"
//                   type="text"
//                   name="mothers_mob_no"
//                   value={values.mothers_mob_no}
//                   onChange={onChange}
//                   pattern="[0-9]{10,11}"
//                   maxLength={10}
//                 />
//               </div>
//               <div className="item15" style={{ display: "flex" }}>
//                 <div style={{ width: "40%" }} className="selecte-dropdown-items" >
//                   <div style={{ marginTop: "2px" }}>
//                     <DropDown
//                       label="Married"
//                       setSelected={(selectedOption) =>
//                         setValues(prev => ({
//                           ...prev,
//                           married_flag: selectedOption,          // 1 = Yes, 0 = No
//                           ...(selectedOption === 0 ? {           // if No → clear spouse fields
//                             spouse_name: "",
//                             spouse_mob_no: ""
//                           } : {})
//                         }))
//                       }
//                       options={[{ label: "Yes", id: 1 }, { label: "No", id: 0 }]}
//                       isRequired={true}
//                     />
//                   </div>
//                 </div>
//                 <div style={{ width: "100%" }}>
//                   <FormInputs
//                     label="Spouse Name"
//                     type="text"
//                     name="spouse_name"
//                     value={values.spouse_name}
//                     onChange={onChange}
//                     maxlength="200"
//                     pattern="[A-Za-z, ]{1,200}"
//                     disabled={values.married_flag !== 1}
//                     required={values.married_flag === 1}
//                   />
//                 </div>
//               </div>
//               <div className="item16">
//                 <FormInputs
//                   label="Spouse’s Mobile Number"
//                   type="text"
//                   name="spouse_mob_no"
//                   value={values.spouse_mob_no}
//                   onChange={onChange}
//                   pattern="[0-9]{10,11}"
//                   maxLength={10}
//                   disabled={values.married_flag !== 1}
//                   required={values.married_flag === 1}
//                 />
//               </div>
//               <div className="item17">
//                 <FormInputs
//                   label="Emergency Contact Name"
//                   type="text"
//                   name="emergency_contact_name"
//                   value={values.emergency_contact_name}
//                   onChange={onChange}
//                   maxlength="200"
//                   pattern="[A-Za-z ]+"
//                 />
//               </div>
//               <div className="item12">
//                 <FormInputs
//                   label="Emergency Contact’s Mobile Number"
//                   type="text"
//                   name="emrgency_contact_mob_no"
//                   value={values.emrgency_contact_mob_no}
//                   onChange={onChange}
//                   pattern="[0-9]{10,11}"
//                   maxLength={10}
//                 />
//               </div>
//             </div>
//           </div>
//         )}
//     </div>
//   );
// }

// export default PersonalInfo;










import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRef } from "react";
import "./registrationfrom.css";
import DropDown from "../../Components/Shared/Dropdown/Dropdown";
import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
import AWS from "aws-sdk";
import UploadImgIcon from "../../Assets/Images/EployeeRegistration/icon-image.png";
import EditIcon from "../../Assets/Images/EployeeRegistration/edit_icon.png";
import { fetchReligionsData } from "../../Redux/EmployeeRegistration/religionSlice";
import { fetchGenderData } from "../../Redux/EmployeeRegistration/genderSlice";
import { fetchBloodGroupData } from "../../Redux/EmployeeRegistration/bloodgroupSlice";
import { fetchSalutationData } from "../../Redux/EmployeeRegistration/salutatinSlice";
import { fetchCategorynData } from "../../Redux/EmployeeRegistration/categorySlice";
import CropperModal from "../StudentRegistration/Cropper";

function PersonalInfo({ setPersonalInfo }) {
  const dispatch = useDispatch();
  const [src, setSrc] = useState(null);
  const { religiondata } = useSelector((state) => state.religion);
  const { genderdata } = useSelector((state) => state.gender);
  const { bloodgroupdata } = useSelector((state) => state.bloodgroup);
  const { salutationdata } = useSelector((state) => state.salutations);
  const { categorydata } = useSelector((state) => state.categories);
  const [isOpen, setIsOpen] = useState(true);
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const cropperRef = useRef(null);
  const [croppedImageBlob, setCroppedImageBlob] = useState(null);
  const [crop, setCrop] = useState(null);
  const [image, setImage] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  const [fileName, setFileName] = useState("");
  const [values, setValues] = useState({
    salutation_id: 0,
    gender_id: 0,
    blood_group_id: 0,
    religion_id: 0,
    category_id: 0,
    emp_first_name: "",
    emp_middle_name: "",
    emp_last_name: "",
    dob: new Date().toISOString(),
    age: null,
    married_flag: "",
    fathers_name: "",
    fathers_mob_no: "",
    mothers_name: "",
    mothers_mob_no: "",
    spouse_name: "",
    spouse_mob_no: "",
    emergency_contact_name: "",
    emrgency_contact_mob_no: "",
    // NOTE: no "photograph" key here — it must never be in the JSON payload
  });

  setPersonalInfo(values);
  // ✅ REMOVED: setPersonalInfo(values) from render body
  // It was causing infinite re-renders and leaking the File/Blob
  // object into the JSON payload as {}.
  // The useEffect below handles syncing correctly.

  useEffect(() => {
    dispatch(fetchGenderData());
    dispatch(fetchBloodGroupData());
    dispatch(fetchReligionsData());
    dispatch(fetchSalutationData());
    dispatch(fetchCategorynData());
  }, [dispatch]);

  const onChange = (e) => {
    const { name, value } = e.target;
    if (name === "dob") {
      const selectedDate = new Date(value);
      const currentDate = new Date();
      const ageDiff = currentDate.getFullYear() - selectedDate.getFullYear();
      const isBirthdayPassed =
        currentDate.getMonth() < selectedDate.getMonth() ||
        (currentDate.getMonth() === selectedDate.getMonth() &&
          currentDate.getDate() < selectedDate.getDate());
      const age = isBirthdayPassed ? ageDiff - 1 : ageDiff;
      setValues({ ...values, [name]: value, age: age });
    } else {
      setValues({ ...values, [name]: value });
    }
    setPersonalInfo((prevInfo) => ({ ...prevInfo, [name]: value }));
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const s3 = new AWS.S3({
    accessKeyId: "AKIAUFB5JPBW5EP45JD7",
    secretAccessKey: "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",
    region: "ap-south-1",
  });

  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const createImage = (url) =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.addEventListener("load", () => resolve(image));
      image.addEventListener("error", (error) => reject(error));
      image.src = url;
    });

  const getCroppedImg = async (imageSrc, pixelCrop) => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(URL.createObjectURL(blob));
      }, "image/jpeg");
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      const reader = new FileReader();
      reader.onload = () => {
        setSrc(reader.result);
        setImage(reader.result);
        setShowCropper(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCroppedImage = (croppedFile) => {
    setCroppedImageBlob(croppedFile);
    setImage(URL.createObjectURL(croppedFile));

    // ✅ Do NOT put the file in values — only pass it up via IMG key
    // so it never ends up serialized in the JSON payload
    setPersonalInfo((prev) => ({
      ...prev,
      IMG: croppedFile,
    }));

    setShowCropper(false);
    setSrc(null);
  };

  const handleCropComplete = async () => {
    if (!cropperRef.current) return;

    try {
      const dataUrl = cropperRef.current.getImage().toDataURL();
      const result = await fetch(dataUrl);
      const blob = await result.blob();

      const timestamp = new Date().getTime();
      const filename = `profile_${timestamp}.jpg`;

      const file = new File([blob], filename, {
        type: "image/jpeg",
        lastModified: Date.now(),
      });

      handleCroppedImage(file);
    } catch (err) {
      console.error("Image processing error:", err);
    }
  };

  const handleDeleteImage = () => {
    setImage(null);
    setSrc(null);
    setFileName("No selected file");
    setCroppedImageBlob(null);
    setShowCropper(false);

    // ✅ Clear IMG from parent — no photograph key needed
    setPersonalInfo((prev) => ({
      ...prev,
      IMG: null,
    }));
  };

  // ✅ This is the ONLY place we sync values → parent
  // croppedImageBlob is kept separate and passed as IMG (not in JSON payload)
  useEffect(() => {
    const currentValues = { ...values };
    if (croppedImageBlob) {
      currentValues.IMG = croppedImageBlob;
      console.log("PersonalInfo - Sending image:", {
        imageSize: croppedImageBlob.size,
        imageType: croppedImageBlob.type,
        imageName: croppedImageBlob.name,
      });
    }
    setPersonalInfo(currentValues);
  }, [values, croppedImageBlob]);

  return (
    <div className="personal-info">
      <div className="personal-header">
        <div className="header">
          <h2>personal information</h2>
          <img src={EditIcon} alt="icon" />
        </div>
        <div className="accordion-btn" onClick={toggleAccordion}>
          {isOpen ? (
            <div className="minus"></div>
          ) : (
            <div className="plus">+</div>
          )}
        </div>
      </div>
      {isOpen &&
        religiondata &&
        genderdata &&
        bloodgroupdata &&
        salutationdata &&
        categorydata && (
          <div className="accordion-content">
            <div className="grid-container">
              <div className="item1" style={{ display: "flex" }}>
                <div className="selecte-dropdown-items" style={{ width: "40%" }}>
                  <div style={{ marginTop: "2px" }}>
                    <DropDown
                      label="Salutation"
                      setSelected={(selectedOption) =>
                        setValues({ ...values, salutation_id: selectedOption })
                      }
                      options={salutationdata.map((salutation) => ({
                        label: salutation.description,
                        id: salutation.salutation_id,
                      }))}
                      isRequired={true}
                    />
                  </div>
                </div>
                <div style={{ width: "100%" }}>
                  <FormInputs
                    label="First Name"
                    type="text"
                    name="emp_first_name"
                    value={values.emp_first_name}
                    onChange={onChange}
                    required
                    maxlength="50"
                    pattern="[A-Za-z]{1,50}"
                  />
                </div>
              </div>
              <div className="item2">
                <FormInputs
                  label="Middle Name"
                  type="text"
                  name="emp_middle_name"
                  value={values.emp_middle_name}
                  onChange={onChange}
                  maxlength="50"
                  pattern="[A-Za-z]{1,50}"
                />
              </div>
              <div className="item3">
                <FormInputs
                  label="Last Name"
                  type="text"
                  name="emp_last_name"
                  value={values.emp_last_name}
                  onChange={onChange}
                  maxlength="50"
                  pattern="[A-Za-z]{1,50}"
                  required
                />
              </div>
              <div className="item4">
                <FormInputs
                  label="Date of Birth"
                  type="date"
                  name="dob"
                  value={values.dob}
                  onChange={onChange}
                />
              </div>
              <div className="item5">
                <FormInputs
                  label="Age"
                  type="number"
                  name="age"
                  value={values.age}
                  onChange={onChange}
                  required
                  max="9999"
                />
              </div>
              <div className="item6">
                <div className="selecte-dropdown-items">
                  <DropDown
                    label="Gender"
                    setSelected={(selectedOption) =>
                      setValues({ ...values, gender_id: selectedOption })
                    }
                    options={genderdata.map((gender) => ({
                      label: gender.gender_name,
                      id: gender.gender_id,
                    }))}
                    isRequired={true}
                  />
                </div>
              </div>
              <div className="item7">
                <div className="selecte-dropdown-items">
                  <DropDown
                    label="Blood Group"
                    setSelected={(selectedOption) =>
                      setValues({
                        ...values,
                        blood_group_id: selectedOption ? selectedOption : 1,
                      })
                    }
                    options={bloodgroupdata.map((bloodgr) => ({
                      label: bloodgr.blood_group_code,
                      id: bloodgr.blood_group_id,
                    }))}
                    isRequired={true}
                  />
                </div>
              </div>
              <div className="item8">
                <div className="selecte-dropdown-items">
                  <DropDown
                    label="Religion"
                    setSelected={(selectedOption) =>
                      setValues({ ...values, religion_id: selectedOption })
                    }
                    options={religiondata.map((rel) => ({
                      label: rel.religion_name,
                      id: rel.religion_id,
                    }))}
                    isRequired={true}
                  />
                </div>
              </div>
              <div className="item9">
                <div className="selecte-dropdown-items">
                  <DropDown
                    label="Category"
                    setSelected={(selectedOption) =>
                      setValues({
                        ...values,
                        category_id: selectedOption ? selectedOption : 1,
                      })
                    }
                    options={categorydata.map((cat) => ({
                      label: cat.category_desc,
                      id: cat.category_id,
                    }))}
                    isRequired={true}
                  />
                </div>
              </div>
              <div className="item10">
                <FormInputs
                  label="Father's Name"
                  type="text"
                  name="fathers_name"
                  value={values.fathers_name}
                  onChange={onChange}
                  required
                  maxlength="200"
                  pattern="[A-Za-z, ]{1,200}"
                />
              </div>
              <div className="item11" style={{ display: "flex" }}>
                <FormInputs
                  label="Father's Mobile Number"
                  type="text"
                  name="fathers_mob_no"
                  value={values.fathers_mob_no}
                  onChange={onChange}
                  pattern="[0-9]{10,11}"
                  maxLength={10}
                />
              </div>
              <div
                className="item12"
                style={{
                  gridRowStart: "4",
                  gridRowEnd: "8",
                  gridColumnStart: "3",
                  gridColumnEnd: "3",
                }}
              >
                <div style={{ width: "100%" }}>
                  <label>Photograph</label>
                  <div className="input-image">
                    <div className="input-image-field">
                      <input
                        type="file"
                        accept="image/*"
                        name="photograph"
                        className="input-field"
                        hidden
                        onChange={handleImageChange}
                      />
                      {!showCropper ? (
                        <>
                          {image ? (
                            <div
                              style={{
                                width: "200px",
                                height: "200px",
                                overflow: "hidden",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                              }}
                            >
                              <img
                                className="uploaded-img"
                                src={image}
                                alt={fileName}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                          ) : (
                            <div className="icon-img-container">
                              <img
                                src={UploadImgIcon}
                                alt="upload icon"
                                className="icon-img"
                              />
                            </div>
                          )}
                        </>
                      ) : (
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            height: "300px",
                          }}
                        >
                          <CropperModal src={src} cropperRef={cropperRef} />
                        </div>
                      )}
                    </div>
                    <div className="image-btns-container">
                      {showCropper ? (
                        <>
                          <div
                            className="replace-image-btn"
                            style={{ marginBottom: "10px" }}
                            onClick={handleCropComplete}
                          >
                            Save Changes
                          </div>
                          <div
                            className="replace-image-btn"
                            onClick={() =>
                              document.querySelector(".input-field").click()
                            }
                          >
                            Replace
                          </div>
                          <div
                            className="del-image-btn"
                            onClick={handleDeleteImage}
                          >
                            Delete
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            className="replace-image-btn"
                            onClick={() =>
                              document.querySelector(".input-field").click()
                            }
                          >
                            {image ? "Replace" : "Upload"}
                          </div>
                          {image && (
                            <div
                              className="del-image-btn"
                              onClick={handleDeleteImage}
                            >
                              Delete
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="item13">
                <FormInputs
                  label="Mother's Name"
                  type="text"
                  name="mothers_name"
                  value={values.mothers_name}
                  onChange={onChange}
                  maxlength="200"
                  pattern="[A-Za-z, ]{1,200}"
                />
              </div>
              <div className="item14">
                <FormInputs
                  label="Mother's Mobile Number"
                  type="text"
                  name="mothers_mob_no"
                  value={values.mothers_mob_no}
                  onChange={onChange}
                  pattern="[0-9]{10,11}"
                  maxLength={10}
                />
              </div>
              <div className="item15" style={{ display: "flex" }}>
                <div style={{ width: "40%" }} className="selecte-dropdown-items">
                  <div style={{ marginTop: "2px" }}>
                    <DropDown
                      label="Married"
                      setSelected={(selectedOption) =>
                        setValues(prev => ({
                          ...prev,
                          married_flag: selectedOption,
                          ...(selectedOption === 0 ? {
                            spouse_name: "",
                            spouse_mob_no: ""
                          } : {})
                        }))
                      }
                      options={[{ label: "Yes", id: 1 }, { label: "No", id: 0 }]}
                      isRequired={true}
                    />
                  </div>
                </div>
                <div style={{ width: "100%" }}>
                  <FormInputs
                    label="Spouse Name"
                    type="text"
                    name="spouse_name"
                    value={values.spouse_name}
                    onChange={onChange}
                    maxlength="200"
                    pattern="[A-Za-z, ]{1,200}"
                    disabled={values.married_flag !== 1}
                    required={values.married_flag === 1}
                  />
                </div>
              </div>
              <div className="item16">
                <FormInputs
                  label="Spouse's Mobile Number"
                  type="text"
                  name="spouse_mob_no"
                  value={values.spouse_mob_no}
                  onChange={onChange}
                  pattern="[0-9]{10,11}"
                  maxLength={10}
                  disabled={values.married_flag !== 1}
                  required={values.married_flag === 1}
                />
              </div>
              <div className="item17">
                <FormInputs
                  label="Emergency Contact Name"
                  type="text"
                  name="emergency_contact_name"
                  value={values.emergency_contact_name}
                  onChange={onChange}
                  maxlength="200"
                  pattern="[A-Za-z ]+"
                />
              </div>
              <div className="item12">
                <FormInputs
                  label="Emergency Contact's Mobile Number"
                  type="text"
                  name="emrgency_contact_mob_no"
                  value={values.emrgency_contact_mob_no}
                  onChange={onChange}
                  pattern="[0-9]{10,11}"
                  maxLength={10}
                />
              </div>
            </div>
          </div>
        )}
    </div>
  );
}

export default PersonalInfo;